import { render } from "./insure-daily-operate-record.vue?vue&type=template&id=6cbbda8a&scoped=true&ts=true"
import script from "./insure-daily-operate-record.vue?vue&type=script&lang=ts"
export * from "./insure-daily-operate-record.vue?vue&type=script&lang=ts"

import "./insure-daily-operate-record.vue?vue&type=style&index=0&id=6cbbda8a&lang=stylus&scoped=true"

import exportComponent from "/Users/yangwenqi/Desktop/蓝豚/web/pc-customer-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cbbda8a"]])

export default __exports__